import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CFEventForCreate } from '../../models/events/cf-event-for-create';
import { CFEventToDisplay } from '../../models/events/cf-event-to-display';
import { KeyValuePairEnum } from '../../models/key-value-pair-enum';

@Injectable({ providedIn: 'root' })
export class CFEventService {
    private apiUrl = environment.apiUrl + '/api/documents';

    constructor(private http: HttpClient) {}

    getEvents(cloudFlowId: string): Observable<Array<CFEventToDisplay>> {
        return this.http.get<Array<CFEventToDisplay>>(`${this.apiUrl}/${cloudFlowId}/events`);
    }

    getEventTypes(): Observable<Array<KeyValuePairEnum>> {
        return this.http.get<Array<KeyValuePairEnum>>(`${this.apiUrl}/events/event-types`);
    }

    registerEvent(documentType: number, companyId: string, externalId: string, file: File, newEvent: CFEventForCreate): Observable<any> {
        const formData = new FormData();

        formData.append('title', newEvent.title);
        formData.append('eventType', newEvent.eventType.toString());
        formData.append('eventId', newEvent.eventId);
        formData.append('documentHash', newEvent.documentHash);
        formData.append('participantEmail', newEvent.participantEmail);

        if (file) {
            formData.append('file', file, file.name);
        }

        if (newEvent.mention) {
            formData.append('mention', newEvent.mention);
        }

        if (newEvent.status) {
            formData.append('status', newEvent.status);
        }

        formData.append('sendNotification', newEvent.sendNotification ? 'true' : 'false');

        return this.http.post(`${this.apiUrl}/${documentType}/${companyId}/${externalId}/events`, formData);
    }
}
